import { freeze } from '@reduxjs/toolkit';
import { PermissionKey } from '../../../utils/apollo/graphqlSchema';
import { appRoutes, ISidebarLink } from '../../../path';

export const cohortsNavLinks = freeze<ISidebarLink[]>(
  [
    {
      title: 'Create Cohort',
      icon: 'create-cohort',
      url: appRoutes.cohorts.create,
      tooltip: {
        content: `Create and manage cohorts which are defined as groups
    of users all fitting a certain set of criteria within the same time period. `,
        actionText: 'Learn More',
        actionUrl: 'https://docs.kubit.ai/docs/cohorts',
      },
      permissionKeys: [PermissionKey.CohortReportRead],
    },
    {
      title: 'View Cohorts',
      icon: 'formula-cohort',
      url: appRoutes.cohorts.view,
      tooltip: {
        content: `View and manage all saved Cohorts.`,
      },
      permissionKeys: [PermissionKey.CohortRead],
    },
  ],
  true,
);
